/**
 * Authentication routes
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import { SignIn, SignUp } from '@clerk/clerk-react';

/** Auth page component */
export function AuthPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/30">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold">FrameIt</h1>
          <p className="text-muted-foreground mt-2">
            Professional artwork framing made easy
          </p>
        </div>

        <Routes>
          <Route
            path="sign-in/*"
            element={
              <SignIn
                routing="path"
                path="/auth/sign-in"
                signUpUrl="/auth/sign-up"
                afterSignInUrl="/editor"
              />
            }
          />
          <Route
            path="sign-up/*"
            element={
              <SignUp
                routing="path"
                path="/auth/sign-up"
                signInUrl="/auth/sign-in"
                afterSignUpUrl="/editor"
              />
            }
          />
          <Route path="*" element={<Navigate to="sign-in" replace />} />
        </Routes>
      </div>
    </div>
  );
}
